import React from "react";

import './styles.scss';

import {account$} from "../../../../../../emitters/account";
import {default as ExitToApp} from "@material-ui/icons/ExitToApp";
import Ripple from "../../../../../dumb/Ripple";
import MerchantDropdownAccount from "../../../helpers/MerchantDropdownAccount";
import formDropdownList from "./utils/formDropdownList";

export default () => {
  const account = account$.getValue() || {};
  const accountsList = account.accountsList || [];

  const logout = account$.signOut;

  return accountsList.length
    ? (
      <MerchantDropdownAccount
        dropdownItems={formDropdownList(account)}
        accountName={account.username}
      />
    ) : (
      <div className="auth-account">
        {account.username || ''}
        <Ripple
          className="auth-account__btn"
          onClick={logout}
        >
          <ExitToApp />
        </Ripple>
      </div>
    )
}
